import React, { useCallback, useMemo, useState } from 'react';
import { Text } from '../../../mo-gel';

import Logo from '../../../images/BTI_logo_2020_white-blue.svg';
import LogoDark from '../../../images/BTI_logo_2020_black-blue.svg';

import {
  StyledHeader,
  StyledLinkItem,
  StyledNavigationItem,
  StyledNavigationList,
  StyledSubNavigation,
  StyledNavigationItemText,
  StyledSubNavItem,
  StyledImageNav,
  StyledNavigationItemWrapper
} from './DesktopHeader.styled';
import { Link } from '../../../typings/Links.type';

export interface DesktopHeaderProps {
  navLinks: Link[];
  whoForNavLinks: Link[];
}

export const DesktopHeader = ({ navLinks, whoForNavLinks }: DesktopHeaderProps) => {
  const [hover, setHover] = useState(false);

  const handleMouseEnter = useCallback(() => setHover(true), []);
  const handleMouseLeave = useCallback(() => setHover(false), []);

  const subNavigationLinks = useMemo(
    () => (
      <StyledSubNavigation $hover={hover}>
        {whoForNavLinks.map((subNav, subIndex) => (
          <StyledSubNavItem to={subNav.link} key={`sub-navigation-link-${subIndex}`} onClick={handleMouseLeave}>
            <Text>{subNav.title}</Text>
          </StyledSubNavItem>
        ))}
      </StyledSubNavigation>
    ),
    [hover, whoForNavLinks, handleMouseLeave]
  );

  return (
    <StyledHeader hover={hover}>
      <StyledImageNav to="/" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <img src={hover ? LogoDark : Logo} alt="home page" />
      </StyledImageNav>
      <StyledNavigationList>
        {navLinks.map((navLink, index) => (
          <React.Fragment key={`navigation-link-${index}`}>
            {navLink.title === 'Login' ? (
              <StyledLinkItem
                href="https://cloud.scorm.com/sc/InvitationConfirmEmail?publicInvitationId=2bba9498-5893-4585-b47a-2a202d020923"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <StyledNavigationItemText>{navLink.title}</StyledNavigationItemText>
              </StyledLinkItem>
            ) : navLink.title === "Who's it for?" ? (
              <StyledNavigationItemWrapper onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <StyledNavigationItem to={navLink.link} title={navLink.title}>
                  <StyledNavigationItemText>{navLink.title}</StyledNavigationItemText>
                </StyledNavigationItem>
                {subNavigationLinks}
              </StyledNavigationItemWrapper>
            ) : (
              <StyledNavigationItem
                to={navLink.link}
                title={navLink.title}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <StyledNavigationItemText>{navLink.title}</StyledNavigationItemText>
              </StyledNavigationItem>
            )}
          </React.Fragment>
        ))}
      </StyledNavigationList>
    </StyledHeader>
  );
};
